import dashboardSlice from './slice'

const { enableDashboard, disableDashboard } = dashboardSlice.actions

export { enableDashboard, disableDashboard }

export default dashboardSlice.reducer
